import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { UpdateUserNotificationsVariables as UpdateUserNotificationsVariablesGenerated } from "core/queries/__generated__/UpdateUserNotifications";

// we fake the following three interfaces and use them instead of the ones in core/queries/__generated__/UpdateUserNotifications"
// We do this to be able to create a fake optimistic response
// Note that this doesn't perfectly match the response signature of the actual mutation.
// This directly sets the cache to be respective of the optimistic response's effects.
// We can remove this if it is causing issues.

// using UpdateUserNotificationsGenerated instead of UpdateUserNotifications_updateUserNotifications_notifications
export interface UpdateUserNotificationsGenerated {
  __typename: "UserNotification";
  id: string;
  archived: boolean;
  success: boolean;
}

// using UpdateUserNotificationsPayloadGenerated instead of UpdateUserNotifications_updateUserNotifications
export interface UpdateUserNotificationsPayloadGenerated {
  __typename: "UpdateNotificationsPayload";
  notification: UpdateUserNotificationsGenerated;
}

// using UpdateUserNotifications instead of UpdateUserNotifications
export interface UpdateUserNotifications {
  updateUserNotifications: UpdateUserNotificationsPayloadGenerated | null;
}

export interface UpdateUserNotificationsResponse
  extends UpdateUserNotifications {}
export interface UpdateUserNotificationVariables
  extends UpdateUserNotificationsVariablesGenerated {}

export const updateUserNotifications = gql`
  mutation UpdateUserNotifications(
    $archive: Boolean!
    $notificationIds: [ID!]
  ) {
    updateUserNotifications(
      archive: $archive
      notificationIds: $notificationIds
    ) {
      success
    }
  }
`;

interface UseUpdateUserNotificationsQueryOptions {
  awaitRefetchQueries?: boolean;
  optimisticResponse?: UpdateUserNotificationsResponse;
  refetchQueries?: string[];
}

type OptimisticResponse = Omit<UpdateUserNotificationsGenerated, "__typename">;
export const updateUserNotificationsOptimisticResponse = (
  response: OptimisticResponse,
) => ({
  updateUserNotifications: {
    notification: {
      id: response.id,
      archived: response.archived,
      success: true,
      __typename:
        "UserNotification" as UpdateUserNotificationsGenerated["__typename"],
    },
    __typename:
      "UpdateNotificationPayload" as UpdateUserNotificationsPayloadGenerated["__typename"],
  },
});

export const useUpdateUserNotifications = ({
  awaitRefetchQueries,
  optimisticResponse,
  refetchQueries = [],
}: UseUpdateUserNotificationsQueryOptions) =>
  useMutation<UpdateUserNotificationsResponse, UpdateUserNotificationVariables>(
    updateUserNotifications,
    {
      awaitRefetchQueries,
      optimisticResponse,
      refetchQueries,
    },
  );
